import aboutHeadshot from '../assets/home/about-headshot-paint.webp';
import aboutHeadshotNight from '../assets/home/about-headshot-paint-night.webp';
import muralFooterDay from '../assets/home/mural-footer-seattle.webp';
import muralFooterNight from '../assets/home/mural-footer-seattle-night.webp';
import { caseStudyOrder, projects } from './projects';

const bySlug = Object.fromEntries(
  projects.filter((p) => p.slug).map((p) => [p.slug, p])
);

/* Figma — Landing Desktop 1440 (5316:2041) */
export const heroSection = {
  headlineBefore: 'Hi, I’m Nivedha, a product ',
  headlineAccent: 'designer',
  headlineAfter: ',',
  headlineLine2: 'engineer, analyst, and consultant.',
  intro:
    'Driven by curiosity, I have designed and shipped B2B and B2C products across fintech, e-commerce, healthcare, and hospitality. I like asking questions and learning as I go.',
};

/**
 * Case grid — four live studies on plain color plates.
 * Plate hues sampled from each case’s paint wash; media from the study itself.
 */
const caseCards = {
  'oracle-payments': {
    tone: 'oracle',
    title:
      'Sole designer for Oracle’s cloud payments platform, used by 2,500+ organizations.',
  },
  'qr-pay': {
    tone: 'qr',
    title:
      'Redesigned Oracle QR Pay to reduce checkout friction and speed up table turns.',
  },
  kit: {
    tone: 'kit',
    title:
      'Designed Kit, a decision tool that helps coaches narrow 300 players to 5 recruits.',
  },
  ditto: {
    tone: 'ditto',
    title:
      'Designed and shipped an AI party game with live image generation in 5 days.',
  },
};

/* Order comes from caseStudyOrder, so the grid and the Next cards always agree */
export const meadowCases = caseStudyOrder.map((id) => ({
  id,
  ...caseCards[id],
  project: bySlug[id],
}));

export const playSection = {
  label: 'Play',
  lede: 'Small projects, experiments, and creative rabbit holes I’ve wandered into.',
  items: [
    { id: 'play-1', title: 'Coming soon', comingSoon: true },
    { id: 'play-2', title: 'Coming soon', comingSoon: true },
    { id: 'play-3', title: 'Coming soon', comingSoon: true },
  ],
};

export const aboutSection = {
  title: 'About',
  headshot: aboutHeadshot,
  headshotNight: aboutHeadshotNight,
  headshotAlt: 'Nivedha holding the book 101 Design Methods',
  lead: 'I like asking questions and learning as I go.',
  paragraphs: [
    'I started out building financial data systems at Deloitte before transitioning into UX design at Oracle. To deepen my product thinking after moving countries, I completed my master’s in HCI + Design at the University of Washington.',
    'Lately, my curiosity has me using AI to build small tools for my own life, partly to make things easier, but mostly because I love seeing an idea come to life.',
    'Outside of design, I enjoy exploring the outdoors, fostering rescue pets, and getting lost in a good story. Whether it’s a book, a documentary, or a conversation, I love things that give me a new perspective on the world and my work.',
  ],
};

export const resumeSection = {
  title: 'Resume',
  lede: '7+ years across product design, data engineering, and business consulting.',
  downloadLabel: 'Download ↓',
  downloadHref: '/files/Nivedha-Shanmugam-Resume.pdf',
  entries: [
    {
      id: 'vit',
      kind: 'study',
      when: '2012–2016',
      role: 'B.Tech in Electronics',
      summary: 'Started with a curiosity for technology and how things work.',
    },
    {
      id: 'deloitte',
      when: '2016–2021',
      role: 'Consultant',
      summary:
        'Tackled complex data problems for some of the world’s largest banks.',
    },
    {
      id: 'oracle',
      when: '2022–2023',
      role: 'UX Designer',
      summary: 'Shipped enterprise and consumer products for Oracle.',
    },
    {
      id: 'uw',
      when: '2025–2026',
      role: 'M.S. in HCI + Design',
      summary: 'Experimented with AI, pushed my boundaries as a designer, and explored what excites me.',
      current: true,
    },
  ],
};

export const contactSection = {
  title: 'Got a challenge that needs a versatile designer?',
  lede: 'Let’s connect.',
  emailLabel: 'Email me →',
  emailHref: 'mailto:nivedha1994@gmail.com',
  linkedinLabel: 'LinkedIn ↗',
  linkedinHref: 'https://www.linkedin.com/in/nivedha-shanmugam/',
  resumeLabel: 'Resume ↓',
};

export const footerSection = {
  name: 'Nivedha',
  role: 'Product Designer',
  mural: muralFooterDay,
  muralDusk: muralFooterNight,
  credit: 'Designed and built by Nivedha',
};
